export default __webpack_public_path__ + "static/media/36I-114288_-20996_0.aff3be25.jpg";